export default {
  header: 'Menu',
  tabs: {
    menu: 'Menu',
    modifier_groups: 'Modificatoren',
  },
  toasts: {
    failed_to_load_data: 'Menu laden mislukt. Vernieuw de pagina en probeer opnieuw',
  },
};
